module.exports = __webpack_public_path__ + "static/media/ID.3ad4bd18.svg";